import React, { useEffect, useRef, useState, useCallback } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "./Conversa.css";

const Conversa = () => {
  const videoRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
      delay: 100,
    });
  }, []);

  useEffect(() => {
    const currentVideoRef = videoRef.current;

    const observer = new IntersectionObserver(
      (entries) => {
        const [entry] = entries;
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      {
        threshold: 0.25,
      }
    );

    if (currentVideoRef) {
      observer.observe(currentVideoRef);
    }

    return () => {
      if (currentVideoRef) observer.unobserve(currentVideoRef);
    };
  }, []);

  const handleVideoEnd = useCallback(() => {
    if (videoRef.current) {
      videoRef.current.pause();
      videoRef.current.currentTime = 0;
    }
  }, []);

  const handleVideoError = useCallback((e) => {
    console.error("Erro ao carregar o vídeo:", e);
  }, []);

  useEffect(() => {
    const videoElement = videoRef.current;

    if (isVisible && videoElement) {
      videoElement.addEventListener("ended", handleVideoEnd);
      videoElement.addEventListener("error", handleVideoError);
    }

    return () => {
      if (videoElement) {
        videoElement.removeEventListener("ended", handleVideoEnd);
        videoElement.removeEventListener("error", handleVideoError);
      }
    };
  }, [isVisible, handleVideoEnd, handleVideoError]);

  return (
    <div className="conversa-section">
      <div className="conversa-layout-grid">
        <div className="conversa-text-content">
          
          <div className="conversa-header">
            <h2 className="conversa-title" data-aos="fade-right">
              Mas antes, uma primeira conversa...
            </h2>
          
            <p className="conversa-description" data-aos="fade-right">
              É uma satisfação oferecer um espaço dedicado a cuidar de sua
              autoestima, necessidades e desejos com atenção, carinho e
              segurança. Estamos preparados e dispostos a ajudar você a se
              sentir ainda mais confiante.
            </p>
          </div>
          
          <div className="to-link" data-aos="fade-right">
            <a href="/contato" className="custom-button">
              Saiba mais aqui
            </a>
          </div>
        </div>

        <div className="welcome-media" data-aos="fade-up" ref={videoRef}>
          {isVisible && (
            <video
              className="welcome-video"
              poster="/images/conversa/thumb.jpg"
              controls
              style={{ objectFit: "cover" }}
            >
              <source src="/images/conversa/bem-vinda.mp4" type="video/mp4" />
              Seu navegador não suporta a tag de vídeo.
            </video>
          )}
        </div>
    </div>
    {" "}
    </div>
  );
};

export default Conversa;
